import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useEffect, useState } from 'react';
const TYPEWRITER_INTERVAL_MS = 25;
const VISIBLE_DURATION_MS = 3000;
const FADE_DURATION_MS = 500;
export const useTypewriterLoop = (param)=>{
    let { disabled, value, suggestions } = param;
    const [state, setState] = useState({
        cycle: 0,
        currentSuggestionIndex: 0,
        displayedText: '',
        isTyping: true,
        opacity: 1
    });
    useEffect(()=>{
        if (disabled || value || suggestions.length === 0) {
            setState({
                cycle: 0,
                currentSuggestionIndex: 0,
                displayedText: '',
                isTyping: false,
                opacity: 0
            });
            return;
        }
        let timeoutId;
        let typingTimeoutId;
        let fadeTimeoutId;
        const currentSuggestion = suggestions[state.currentSuggestionIndex];
        let charIndex = 0;
        const typeNextChar = ()=>{
            if (charIndex < currentSuggestion.length) {
                setState((prev)=>_object_spread_props(_object_spread({}, prev), {
                        displayedText: currentSuggestion.slice(0, charIndex + 1)
                    }));
                charIndex++;
                typingTimeoutId = setTimeout(typeNextChar, TYPEWRITER_INTERVAL_MS);
            } else {
                setState((prev)=>_object_spread_props(_object_spread({}, prev), {
                        isTyping: false
                    }));
                timeoutId = setTimeout(()=>{
                    setState((prev)=>_object_spread_props(_object_spread({}, prev), {
                            opacity: 0
                        }));
                    fadeTimeoutId = setTimeout(()=>{
                        setState((prev)=>({
                                cycle: prev.cycle + 1,
                                currentSuggestionIndex: (prev.currentSuggestionIndex + 1) % suggestions.length,
                                displayedText: '',
                                isTyping: true,
                                opacity: 1
                            }));
                    }, FADE_DURATION_MS);
                }, VISIBLE_DURATION_MS);
            }
        };
        setState((prev)=>_object_spread_props(_object_spread({}, prev), {
                opacity: 1,
                isTyping: true,
                displayedText: ''
            }));
        typeNextChar();
        return ()=>{
            clearTimeout(timeoutId);
            clearTimeout(typingTimeoutId);
            clearTimeout(fadeTimeoutId);
        };
    }, [
        disabled,
        value,
        state.cycle,
        state.currentSuggestionIndex,
        suggestions
    ]);
    return {
        displayedText: state.displayedText,
        isTyping: state.isTyping,
        opacity: state.opacity,
        duration: FADE_DURATION_MS / 1000
    };
};
